import React from 'react';
import {
  TYPOGRAPHY,
  TYPOGRAPHY_COLOR,
  TYPOGRAPHY_SIZE,
  TYPOGRAPHY_STYLE,
} from '../../constants';
import { constructClassName } from '../../helper/common';
import { Typography as ATypography } from 'antd';
import styles from './Typographys.module.scss';
import { useNavigate } from 'react-router-dom';
import { useThemeContext } from '../../theme/GlobalTheme';
import { useBreakpoint } from '../../hooks';
import useBreakpoints from '../../hooks/useBreakpoints';

function getClubbedClassName({
  baseClass,
  className,
  fontColor,
  fontStyle,
  fontSize,
  theme,
}) {
  return [
    baseClass,
    className,
    styles[`font-color-${fontColor}-${theme}`],
    styles[`font-style-${fontStyle}`],
    styles[`font-size-${fontSize}`],
  ];
}

function ActionLink({
  to,
  text,
  className,
  fontColor = TYPOGRAPHY_COLOR.PRIMARY_PURPLE,
  fontStyle = TYPOGRAPHY_STYLE.BOLD,
  fontSize = TYPOGRAPHY_SIZE[16],
  theme,
  onClick,
  ...rest
}) {
  const navigate = useNavigate();
  function handleOnClick() {
    if (to) {
      navigate(to);
    } else if (onClick) {
      onClick();
    }
  }

  return (
    <ATypography.Link
      className={constructClassName(
        getClubbedClassName({
          baseClass: styles['typography-internal-link'],
          className,
          fontColor,
          fontStyle,
          fontSize,
          theme,
        })
      )}
      onClick={handleOnClick}
      {...rest}
    >
      {text}
    </ATypography.Link>
  );
}

function TitleText({
  className,
  fontColor = TYPOGRAPHY_COLOR.BLACK,
  fontStyle = TYPOGRAPHY_STYLE.BOLD,
  fontSize = TYPOGRAPHY_SIZE[32],
  text,
  theme,
  ...rest
}) {
  return (
    <ATypography.Title
      className={constructClassName(
        getClubbedClassName({
          baseClass: styles['typography-title'],
          className,
          fontColor,
          fontStyle,
          fontSize,
          theme,
        })
      )}
      {...rest}
    >
      {text}
    </ATypography.Title>
  );
}
function TitleTextLite({
  className,
  fontColor = TYPOGRAPHY_COLOR.BLACK,
  fontStyle = TYPOGRAPHY_STYLE.SEMI_BOLD,
  fontSize = TYPOGRAPHY_SIZE[32],
  text,
  theme,
  ...rest
}) {
  return (
    <ATypography.Title
      className={constructClassName(
        getClubbedClassName({
          baseClass: styles['typography-title'],
          className,
          fontColor,
          fontStyle,
          fontSize,
          theme,
        })
      )}
      {...rest}
    >
      {text}
    </ATypography.Title>
  );
}
function TitleLitePurple({
  className,
  fontColor = TYPOGRAPHY_COLOR.PRIMARY_PURPLE,
  fontStyle = TYPOGRAPHY_STYLE.SEMI_BOLD,
  fontSize = TYPOGRAPHY_SIZE[32],
  text,
  theme,
  ...rest
}) {
  return (
    <ATypography.Title
      className={constructClassName(
        getClubbedClassName({
          baseClass: styles['typography-title'],
          className,
          fontColor,
          fontStyle,
          fontSize,
          theme,
        })
      )}
      {...rest}
    >
      {text}
    </ATypography.Title>
  );
}

function SubTitleText({
  className,
  fontColor = TYPOGRAPHY_COLOR.DEEP_PURPLE,
  fontStyle = TYPOGRAPHY_STYLE.BOLD,
  fontSize = TYPOGRAPHY_SIZE[18],
  text,
  theme,
  ...rest
}) {
  return (
    <ATypography.Paragraph
      className={constructClassName(
        getClubbedClassName({
          baseClass: styles['typography-subtitle'],
          className,
          fontColor,
          fontStyle,
          fontSize,
          theme,
        })
      )}
      {...rest}
    >
      {text}
    </ATypography.Paragraph>
  );
}
function SubTitleTextBlack({
  className,
  fontColor = TYPOGRAPHY_COLOR.BLACK,
  fontStyle = TYPOGRAPHY_STYLE.BOLD,
  fontSize = TYPOGRAPHY_SIZE[18],
  text,
  theme,
  ...rest
}) {
  return (
    <ATypography.Paragraph
      className={constructClassName(
        getClubbedClassName({
          baseClass: styles['typography-subtitle'],
          className,
          fontColor,
          fontStyle,
          fontSize,
          theme,
        })
      )}
      {...rest}
    >
      {text}
    </ATypography.Paragraph>
  );
}

function SubTitleTextBig({
  className,
  fontColor = TYPOGRAPHY_COLOR.DEEP_PURPLE,
  fontStyle = TYPOGRAPHY_STYLE.BOLD,
  fontSize = TYPOGRAPHY_SIZE[22],
  text,
  theme,
  ...rest
}) {
  return (
    <ATypography.Paragraph
      className={constructClassName(
        getClubbedClassName({
          baseClass: styles['typography-subtitle'],
          className,
          fontColor,
          fontStyle,
          fontSize,
          theme,
        })
      )}
      {...rest}
    >
      {text}
    </ATypography.Paragraph>
  );
}
function SubTitleTextBigBlack({
  className,
  fontColor = TYPOGRAPHY_COLOR.BLACK,
  fontStyle = TYPOGRAPHY_STYLE.BOLD,
  fontSize = TYPOGRAPHY_SIZE[22],
  text,
  theme,
  ...rest
}) {
  return (
    <ATypography.Paragraph
      className={constructClassName(
        getClubbedClassName({
          baseClass: styles['typography-subtitle'],
          className,
          fontColor,
          fontStyle,
          fontSize,
          theme,
        })
      )}
      {...rest}
    >
      {text}
    </ATypography.Paragraph>
  );
}
function ParagraphText({
  className,
  fontColor = TYPOGRAPHY_COLOR.GREY,
  fontStyle = TYPOGRAPHY_STYLE.SEMI_BOLD,
  fontSize = TYPOGRAPHY_SIZE[16],
  text,
  theme,
  ...rest
}) {
  return (
    <ATypography.Paragraph
      className={constructClassName(
        getClubbedClassName({
          baseClass: styles['typography-subtitle'],
          className,
          fontColor,
          fontStyle,
          fontSize,
          theme,
        })
      )}
      {...rest}
    >
      {text}
    </ATypography.Paragraph>
  );
}
function ParagraphTextBold({
  className,
  fontColor = TYPOGRAPHY_COLOR.GREY,
  fontStyle = TYPOGRAPHY_STYLE.BOLD,
  fontSize = TYPOGRAPHY_SIZE[16],
  text,
  theme,
  ...rest
}) {
  return (
    <ATypography.Paragraph
      className={constructClassName(
        getClubbedClassName({
          baseClass: styles['typography-subtitle'],
          className,
          fontColor,
          fontStyle,
          fontSize,
          theme,
        })
      )}
      {...rest}
    >
      {text}
    </ATypography.Paragraph>
  );
}
function ParagraphTextPurple({
  className,
  fontColor = TYPOGRAPHY_COLOR.DEEP_PURPLE,
  fontStyle = TYPOGRAPHY_STYLE.SEMI_BOLD,
  fontSize = TYPOGRAPHY_SIZE[16],
  text,
  theme,
  ...rest
}) {
  return (
    <ATypography.Paragraph
      className={constructClassName(
        getClubbedClassName({
          baseClass: styles['typography-subtitle'],
          className,
          fontColor,
          fontStyle,
          fontSize,
          theme,
        })
      )}
      {...rest}
    >
      {text}
    </ATypography.Paragraph>
  );
}

function getFontSize(isMedium, mobileFont, webFontSize) {
  return !isMedium ? TYPOGRAPHY_SIZE[mobileFont] : TYPOGRAPHY_SIZE[webFontSize];
}

function Typography(props) {
  const { themeKey } = useThemeContext();
  const { type, ...rest } = props;
  const { isMedium } = useBreakpoints();

  switch (type) {
    case TYPOGRAPHY.TITLE:
      return (
        <TitleText
          {...rest}
          fontSize={getFontSize(isMedium, 28, 32)}
          theme={themeKey}
        />
      );
    case TYPOGRAPHY.TITLE_LITE:
      return (
        <TitleTextLite
          {...rest}
          fontSize={getFontSize(isMedium, 28, 32)}
          theme={themeKey}
        />
      );
    case TYPOGRAPHY.TITLE_LITE_PURPLE:
      return (
        <TitleLitePurple
          {...rest}
          fontSize={getFontSize(isMedium, 28, 32)}
          theme={themeKey}
        />
      );
    case TYPOGRAPHY.SUBTITLE:
      return (
        <SubTitleText
          {...rest}
          fontSize={getFontSize(isMedium, 16, 18)}
          theme={themeKey}
        />
      );
    case TYPOGRAPHY.SUBTITLE_BLACK:
      return (
        <SubTitleTextBlack
          {...rest}
          fontSize={getFontSize(isMedium, 16, 18)}
          theme={themeKey}
        />
      );
    case TYPOGRAPHY.SUBTITLE_BIG:
      return (
        <SubTitleTextBig
          {...rest}
          fontSize={getFontSize(isMedium, 20, 22)}
          theme={themeKey}
        />
      );
    case TYPOGRAPHY.SUBTITLE_BIG_BLACK:
      return (
        <SubTitleTextBigBlack
          {...rest}
          fontSize={getFontSize(isMedium, 20, 22)}
          theme={themeKey}
        />
      );
    case TYPOGRAPHY.PARA:
      return (
        <ParagraphText
          {...rest}
          fontSize={getFontSize(isMedium, 14, 16)}
          theme={themeKey}
        />
      );
    case TYPOGRAPHY.PARA_BOLD:
      return (
        <ParagraphTextBold
          {...rest}
          fontSize={getFontSize(isMedium, 14, 16)}
          theme={themeKey}
        />
      );
    case TYPOGRAPHY.PARA_PURPLE:
      return (
        <ParagraphTextPurple
          {...rest}
          fontSize={getFontSize(isMedium, 14, 16)}
          theme={themeKey}
        />
      );
    case TYPOGRAPHY.INTERNAL_LINK:
      return (
        <ActionLink
          {...rest}
          fontSize={getFontSize(isMedium, 14, 16)}
          theme={themeKey}
        />
      );
    default:
      return (
        <ATypography.Text {...rest} theme={themeKey}>
          {rest.text}
        </ATypography.Text>
      );
  }
}

export default Typography;
